/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './pages/__root'
import { Route as AppRouteRouteImport } from './pages/_app/route'
import { Route as ChangePasswordRouteImport } from './pages/change-password'
import { Route as AppIndexRouteImport } from './pages/_app/index'
import { Route as AppProfileRouteImport } from './pages/_app/profile'
import { Route as AuthSignInRouteImport } from './pages/_auth/sign-in'
import { Route as AppResourceIndexRouteImport } from './pages/_app/$resource/index'
import { Route as AppResourceCreateRouteImport } from './pages/_app/$resource/create'
import { Route as AppSalesIndexRouteImport } from './pages/_app/sales/index'
import { Route as AppSalesCreateRouteImport } from './pages/_app/sales/create'
import { Route as AppScreensIndexRouteImport } from './pages/_app/screens/index'
import { Route as AppScreensCreateRouteImport } from './pages/_app/screens/create'
import { Route as AppResourceIdIndexRouteImport } from './pages/_app/$resource/$id/index'
import { Route as AppResourceIdViewRouteImport } from './pages/_app/$resource/$id/view'
import { Route as AppSalesIdIndexRouteImport } from './pages/_app/sales/$id/index'
import { Route as AppSalesIdViewRouteImport } from './pages/_app/sales/$id/view'
import { Route as AppScreensIdIndexRouteImport } from './pages/_app/screens/$id/index'
import { Route as AppScreensIdViewRouteImport } from './pages/_app/screens/$id/view'

const AppRouteRoute = AppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const ChangePasswordRoute = ChangePasswordRouteImport.update({
  id: '/change-password',
  path: '/change-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppProfileRoute = AppProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppRouteRoute,
} as any)
const AuthSignInRoute = AuthSignInRouteImport.update({
  id: '/_auth/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const AppResourceIndexRoute = AppResourceIndexRouteImport.update({
  id: '/$resource/',
  path: '/$resource/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppResourceCreateRoute = AppResourceCreateRouteImport.update({
  id: '/$resource/create',
  path: '/$resource/create',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSalesIndexRoute = AppSalesIndexRouteImport.update({
  id: '/sales/',
  path: '/sales/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSalesCreateRoute = AppSalesCreateRouteImport.update({
  id: '/sales/create',
  path: '/sales/create',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppScreensIndexRoute = AppScreensIndexRouteImport.update({
  id: '/screens/',
  path: '/screens/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppScreensCreateRoute = AppScreensCreateRouteImport.update({
  id: '/screens/create',
  path: '/screens/create',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppResourceIdIndexRoute = AppResourceIdIndexRouteImport.update({
  id: '/$resource/$id/',
  path: '/$resource/$id/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppResourceIdViewRoute = AppResourceIdViewRouteImport.update({
  id: '/$resource/$id/view',
  path: '/$resource/$id/view',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSalesIdIndexRoute = AppSalesIdIndexRouteImport.update({
  id: '/sales/$id/',
  path: '/sales/$id/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSalesIdViewRoute = AppSalesIdViewRouteImport.update({
  id: '/sales/$id/view',
  path: '/sales/$id/view',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppScreensIdIndexRoute = AppScreensIdIndexRouteImport.update({
  id: '/screens/$id/',
  path: '/screens/$id/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppScreensIdViewRoute = AppScreensIdViewRouteImport.update({
  id: '/screens/$id/view',
  path: '/screens/$id/view',
  getParentRoute: () => AppRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/change-password': typeof ChangePasswordRoute
  '/profile': typeof AppProfileRoute
  '/sign-in': typeof AuthSignInRoute
  '/$resource/create': typeof AppResourceCreateRoute
  '/sales/create': typeof AppSalesCreateRoute
  '/screens/create': typeof AppScreensCreateRoute
  '/$resource/': typeof AppResourceIndexRoute
  '/sales/': typeof AppSalesIndexRoute
  '/screens/': typeof AppScreensIndexRoute
  '/$resource/$id/view': typeof AppResourceIdViewRoute
  '/sales/$id/view': typeof AppSalesIdViewRoute
  '/screens/$id/view': typeof AppScreensIdViewRoute
  '/$resource/$id/': typeof AppResourceIdIndexRoute
  '/sales/$id/': typeof AppSalesIdIndexRoute
  '/screens/$id/': typeof AppScreensIdIndexRoute
}
export interface FileRoutesByTo {
  '/change-password': typeof ChangePasswordRoute
  '/profile': typeof AppProfileRoute
  '/sign-in': typeof AuthSignInRoute
  '/': typeof AppIndexRoute
  '/$resource/create': typeof AppResourceCreateRoute
  '/sales/create': typeof AppSalesCreateRoute
  '/screens/create': typeof AppScreensCreateRoute
  '/$resource': typeof AppResourceIndexRoute
  '/sales': typeof AppSalesIndexRoute
  '/screens': typeof AppScreensIndexRoute
  '/$resource/$id/view': typeof AppResourceIdViewRoute
  '/sales/$id/view': typeof AppSalesIdViewRoute
  '/screens/$id/view': typeof AppScreensIdViewRoute
  '/$resource/$id': typeof AppResourceIdIndexRoute
  '/sales/$id': typeof AppSalesIdIndexRoute
  '/screens/$id': typeof AppScreensIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteRouteWithChildren
  '/change-password': typeof ChangePasswordRoute
  '/_app/profile': typeof AppProfileRoute
  '/_auth/sign-in': typeof AuthSignInRoute
  '/_app/': typeof AppIndexRoute
  '/_app/$resource/create': typeof AppResourceCreateRoute
  '/_app/sales/create': typeof AppSalesCreateRoute
  '/_app/screens/create': typeof AppScreensCreateRoute
  '/_app/$resource/': typeof AppResourceIndexRoute
  '/_app/sales/': typeof AppSalesIndexRoute
  '/_app/screens/': typeof AppScreensIndexRoute
  '/_app/$resource/$id/view': typeof AppResourceIdViewRoute
  '/_app/sales/$id/view': typeof AppSalesIdViewRoute
  '/_app/screens/$id/view': typeof AppScreensIdViewRoute
  '/_app/$resource/$id/': typeof AppResourceIdIndexRoute
  '/_app/sales/$id/': typeof AppSalesIdIndexRoute
  '/_app/screens/$id/': typeof AppScreensIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/change-password'
    | '/profile'
    | '/sign-in'
    | '/$resource/create'
    | '/sales/create'
    | '/screens/create'
    | '/$resource/'
    | '/sales/'
    | '/screens/'
    | '/$resource/$id/view'
    | '/sales/$id/view'
    | '/screens/$id/view'
    | '/$resource/$id/'
    | '/sales/$id/'
    | '/screens/$id/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/change-password'
    | '/profile'
    | '/sign-in'
    | '/'
    | '/$resource/create'
    | '/sales/create'
    | '/screens/create'
    | '/$resource'
    | '/sales'
    | '/screens'
    | '/$resource/$id/view'
    | '/sales/$id/view'
    | '/screens/$id/view'
    | '/$resource/$id'
    | '/sales/$id'
    | '/screens/$id'
  id:
    | '__root__'
    | '/_app'
    | '/change-password'
    | '/_app/profile'
    | '/_auth/sign-in'
    | '/_app/'
    | '/_app/$resource/create'
    | '/_app/sales/create'
    | '/_app/screens/create'
    | '/_app/$resource/'
    | '/_app/sales/'
    | '/_app/screens/'
    | '/_app/$resource/$id/view'
    | '/_app/sales/$id/view'
    | '/_app/screens/$id/view'
    | '/_app/$resource/$id/'
    | '/_app/sales/$id/'
    | '/_app/screens/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRouteRoute: typeof AppRouteRouteWithChildren
  ChangePasswordRoute: typeof ChangePasswordRoute
  AuthSignInRoute: typeof AuthSignInRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/change-password': {
      id: '/change-password'
      path: '/change-password'
      fullPath: '/change-password'
      preLoaderRoute: typeof ChangePasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/profile': {
      id: '/_app/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AppProfileRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_auth/sign-in': {
      id: '/_auth/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof AuthSignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/$resource/': {
      id: '/_app/$resource/'
      path: '/$resource'
      fullPath: '/$resource/'
      preLoaderRoute: typeof AppResourceIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/$resource/create': {
      id: '/_app/$resource/create'
      path: '/$resource/create'
      fullPath: '/$resource/create'
      preLoaderRoute: typeof AppResourceCreateRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/sales/': {
      id: '/_app/sales/'
      path: '/sales'
      fullPath: '/sales/'
      preLoaderRoute: typeof AppSalesIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/sales/create': {
      id: '/_app/sales/create'
      path: '/sales/create'
      fullPath: '/sales/create'
      preLoaderRoute: typeof AppSalesCreateRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/screens/': {
      id: '/_app/screens/'
      path: '/screens'
      fullPath: '/screens/'
      preLoaderRoute: typeof AppScreensIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/screens/create': {
      id: '/_app/screens/create'
      path: '/screens/create'
      fullPath: '/screens/create'
      preLoaderRoute: typeof AppScreensCreateRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/$resource/$id/': {
      id: '/_app/$resource/$id/'
      path: '/$resource/$id'
      fullPath: '/$resource/$id/'
      preLoaderRoute: typeof AppResourceIdIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/$resource/$id/view': {
      id: '/_app/$resource/$id/view'
      path: '/$resource/$id/view'
      fullPath: '/$resource/$id/view'
      preLoaderRoute: typeof AppResourceIdViewRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/sales/$id/': {
      id: '/_app/sales/$id/'
      path: '/sales/$id'
      fullPath: '/sales/$id/'
      preLoaderRoute: typeof AppSalesIdIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/sales/$id/view': {
      id: '/_app/sales/$id/view'
      path: '/sales/$id/view'
      fullPath: '/sales/$id/view'
      preLoaderRoute: typeof AppSalesIdViewRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/screens/$id/': {
      id: '/_app/screens/$id/'
      path: '/screens/$id'
      fullPath: '/screens/$id/'
      preLoaderRoute: typeof AppScreensIdIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/screens/$id/view': {
      id: '/_app/screens/$id/view'
      path: '/screens/$id/view'
      fullPath: '/screens/$id/view'
      preLoaderRoute: typeof AppScreensIdViewRouteImport
      parentRoute: typeof AppRouteRoute
    }
  }
}

interface AppRouteRouteChildren {
  AppProfileRoute: typeof AppProfileRoute
  AppIndexRoute: typeof AppIndexRoute
  AppResourceCreateRoute: typeof AppResourceCreateRoute
  AppSalesCreateRoute: typeof AppSalesCreateRoute
  AppScreensCreateRoute: typeof AppScreensCreateRoute
  AppResourceIndexRoute: typeof AppResourceIndexRoute
  AppSalesIndexRoute: typeof AppSalesIndexRoute
  AppScreensIndexRoute: typeof AppScreensIndexRoute
  AppResourceIdViewRoute: typeof AppResourceIdViewRoute
  AppSalesIdViewRoute: typeof AppSalesIdViewRoute
  AppScreensIdViewRoute: typeof AppScreensIdViewRoute
  AppResourceIdIndexRoute: typeof AppResourceIdIndexRoute
  AppSalesIdIndexRoute: typeof AppSalesIdIndexRoute
  AppScreensIdIndexRoute: typeof AppScreensIdIndexRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppProfileRoute: AppProfileRoute,
  AppIndexRoute: AppIndexRoute,
  AppResourceCreateRoute: AppResourceCreateRoute,
  AppSalesCreateRoute: AppSalesCreateRoute,
  AppScreensCreateRoute: AppScreensCreateRoute,
  AppResourceIndexRoute: AppResourceIndexRoute,
  AppSalesIndexRoute: AppSalesIndexRoute,
  AppScreensIndexRoute: AppScreensIndexRoute,
  AppResourceIdViewRoute: AppResourceIdViewRoute,
  AppSalesIdViewRoute: AppSalesIdViewRoute,
  AppScreensIdViewRoute: AppScreensIdViewRoute,
  AppResourceIdIndexRoute: AppResourceIdIndexRoute,
  AppSalesIdIndexRoute: AppSalesIdIndexRoute,
  AppScreensIdIndexRoute: AppScreensIdIndexRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AppRouteRoute: AppRouteRouteWithChildren,
  ChangePasswordRoute: ChangePasswordRoute,
  AuthSignInRoute: AuthSignInRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
